import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../service/permission/permission.service';

export const permissionGuard = (
    project: string,
    module: string,
    action: string
): CanActivateFn => {
    return () => {
        const permService = inject(PermissionService);
        const router = inject(Router);

        if (permService.can(project, module, action)) {
            return true;
        }

        router.navigate(['/unauthorized']);
        return false;
    };
};

/**
 * Guard that checks if user has ANY permission in a project.
 * Use on project-level routes.
 */
export const projectAccessGuard = (project: string): CanActivateFn => {
    return () => {
        const permService = inject(PermissionService);
        const router = inject(Router);

        if (permService.hasAnyPermission(project)) {
            return true;
        }

        router.navigate(['/no-access']);
        return false;
    };
};
